import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
// import { getMe } from "./auth";
// import CryptoJS from "crypto-js";
import AppUtil from "../../utilities/AppUtil";

// Main URL Endpoint
const _urlPrefix = "/company-user";


export const fetchCompanyUserListPaging = createAsyncThunk(
  "company-user/fetchCompanyUserListPaging",
  async (params) => {
      const result = await httpRequest({
          url: `${_urlPrefix}/list`,
          method: "GET",
          params: AppUtil.toSnakeCaseKey(params)
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

export const fetchCompanyUserDetail = createAsyncThunk(
  "company-user/fetchCompanyUserDetail",
  async (params) => {
      const { companyId, id } = params;
      const result = await httpRequest({
          url: `${_urlPrefix}/${companyId}/detail/${id}`,
          method: "GET",
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

export const reduceUpdateCompanyUser = createAsyncThunk(
  "company-user/reduceUpdateCompanyUser",
  async (params) => {
      const { companyId, id } = params;
      let request;
      if(params.firstName && params.lastName) {
        request = {
          firstName: params.firstName,
          lastName: params.lastName,
          permissions: params.permissions
        }
      } else {
        request = {
          isEmailCreatedParticipant: params.isEmailCreatedParticipant,
          isEmailOnboard: params.isEmailOnboard,
          permissions: params.permissions
        }
      }
      const result = await httpRequest({
          url:  `${_urlPrefix}/${companyId}/detail/${id}`,
          method: "PUT",
          data: AppUtil.toSnakeCaseKey(request),
          successMessage: 'toast.update.200'
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);


export const reduceDeleteCompanyUser = createAsyncThunk(
  "company-user/reduceDeleteCompanyUser",
  async (params) => {
      const data = {company_id: params.companyId, ids: params.ids};
      const result = await httpRequest({
          url: `${_urlPrefix}/delete`,
          method: "DELETE",
          data: data,
          successMessage: 'toast.remove.200'
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

export const reduceCreateCompanyUser = createAsyncThunk(
  "company-user/reduceCreateCompanyUser",
  async (params) => {
      const result = await httpRequest({
          url: `${_urlPrefix}`,
          method: "POST",
          data: AppUtil.toSnakeCaseKey(params),
          successMessage: 'toast.create.200'
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

const initialState = {
  list: [],
  detail: {}
};

const companyUser = createSlice({
  name: "companyUser",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchCompanyUserListPaging.fulfilled]: (state, action) => {
      const { payload } = action;
      if (payload && payload.content) {
        state.list = payload.content;
      }
      return state;
    },
    [fetchCompanyUserDetail.fulfilled]: (state, action) => {
      const { payload } = action;
      state.detail = payload;
      return state;
    }
  }
});

const { reducer } = companyUser;

export default reducer;

export const getCompanyUserListPaging = createSelector(
  (state) => state.companyUser.list,
  (list) => list
);

export const getCompanyUserDetail = createSelector(
  (state) => state.companyUser.detail,
  (detail) => detail
);